import { render } from "./EditFounder.vue?vue&type=template&id=042d6f6a&scoped=true"
import script from "./EditFounder.vue?vue&type=script&lang=js"
export * from "./EditFounder.vue?vue&type=script&lang=js"

import "./EditFounder.vue?vue&type=style&index=0&id=042d6f6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042d6f6a"]])

export default __exports__